<template>
  <Breadcrumbs :breadcrumbs="breadcrumbs" />

  <DynamicContent
    id="category-content-introduction"
    class="container dynamic-content"
    :html="content?.introductionBlock"
  ></DynamicContent>

  <BrochuresGrid
    :input="{ categorySlug: slug }"
    :pagination="{ limit: 15, offset: 0 }"
    :title="isContentBlockEmpty(content?.introductionBlock) ? $t('category.category-brochures', [categoryName]) : undefined"
    :show-load-more="true"
    :infinite-loading="false"
    :impression-source="BrochureImpressionSource.Category"
  />

  <DynamicContent
    id="category-content-similar"
    class="container dynamic-content"
    :html="content?.similarBlock"
  ></DynamicContent>

  <ShopsGrid
    :input="{
      categorySlug: slug,
    }"
    :pagination="{ limit: 13, offset: 0 }"
    :title="isContentBlockEmpty(content?.similarBlock) ? $t('category.shops') : undefined"
    class="mb-4"
  />

  <DynamicContent
    id="category-content-timed"
    class="container dynamic-content"
    :html="content?.timedBlock"
  ></DynamicContent>
  <DynamicContent
    id="category-content-offers"
    class="container dynamic-content"
    :html="content?.offersBlock"
  ></DynamicContent>
</template>

<script setup lang="ts">
import {
  BrochureImpressionSource,
  useCategoryQuery,
  useWebsitePageQuery,
} from "~/graphql/generated";

false && /*#__PURE__*/ defineI18nRoute({
  paths: {
    "nl-NL": "/categorieen/[slug]",
    fr: "/categories/[slug]",
    nl: "/categorieen/[slug]",
  },
});

const slug = useRoute().params.slug as string;

// Fetch the category by slug
const { data, error, fetching } = await useCategoryQuery({
  variables: {
    categoryInput: {
      id: slug,
    },
  },
});
if (error?.value || !data.value?.category) {
  throw createError({ statusCode: 404, fatal: true });
}

const categoryName = computed(() => {
  return data.value?.category?.name ?? "";
});

// Set the breadcrumbs
const breadcrumbs = ref([
  {
    to: "categories",
  },
  {
    to: "categories-slug",
    text: categoryName, // TODO: Fetch category name from API
  },
]);

// Set the page title and meta
const { t } = useI18n();
const categoryTitle = computed(() => t("brand.title", [categoryName.value.toLowerCase()]));
const categoryDescription = computed(() => data.value?.category?.about || undefined);
const categoryImage = computed(() => data.value?.category?.fileUrl || undefined);

useHead({
  title: categoryTitle,
  meta: [{ name: "description", content: categoryDescription }],
});

useSeoMeta({
  ogTitle: categoryTitle,
  ogDescription: categoryDescription,
  ogImage: categoryImage,
});

// Set the (optional) page content blocks
const path = useRoute().path;
const { websitePagePath } = useWebsitePagePath(path);
const page = await useWebsitePageQuery({ variables: websitePagePath });
const content = useDynamicContent(page.data);
</script>
